import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { memo } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { isMobile } from "react-device-detect";
import clsx from "clsx";

const useStyle = makeStyles({
  fullContainer: {
    maxHeight: "90%",
    textAlign: "left",
    flexGrow: "0",
    margin: "16px 0 0",
    paddingRight: "16px",
  },
  container: {
    maxHeight: "72%",
    textAlign: "left",
    flexGrow: "0",
    margin: "16px 0 0",
    paddingRight: "16px",
  },
  fullContainer_mb: {
    maxHeight: "85%",
    textAlign: "left",
    flexGrow: "0",
    margin: "16px 0 0",
    paddingRight: "16px",
  },
  container_mb: {
    maxHeight: "70%",
    textAlign: "left",
    flexGrow: "0",
    margin: "16px 0 0",
    paddingRight: "16px",
  },
  textContent: {
    fontFamily: "DB Heavent",
  },
  paddingTopBottom: {
    padding: "10px 0",
  },
  fixHeight: {
    maxHeight: "80%",
    textAlign: "left",
    flexGrow: "0",
    margin: "16px 0 0",
    paddingRight: "16px",
  },
  fixHeight_mb: {
    maxHeight: "80%",
    textAlign: "left",
    flexGrow: "0",
    margin: "16px 0 0",
    paddingRight: "16px",
  },
  summaryContainer: {
    // maxHeight: "150%",
    // marginBottom: "20%",
    maxHeight: "90%",
    width: "100%",
    textAlign: "left",
    flexGrow: "0",
    margin: "16px 0 0",
    paddingRight: "16px",
  },
});

const PanelScrollBar = (props) => {
  const classes = useStyle();
  const { content, size, fixHeight, summary } = props;
  const onConfirmRead = (read) => {
    if (props.confirmRead) {
      props.confirmRead(read);
    }
  };
  const handleUpdate = (e) => {
    if (e.top >= 0.99) {
      onConfirmRead(true);
    }
  };
  return (
    <>
      <Scrollbars
        className={clsx(
          // isMobile
          //   ? size === "full"
          //     ? classes.fullContainer_mb
          //     : summary
          //     ? classes.summaryContainer
          //     : fixHeight
          //     ? "fixHeight"
          //     : "content-consent-mb"
          //   : size === "full"
          //   ? classes.fullContainer
          //   : summary
          //   ? classes.summaryContainer
          //   : fixHeight
          //   ? "fixHeight"
          //   : "box-container"
          isMobile ? "fixHeight" : "box-container"
        )}
        onUpdate={handleUpdate}
        autoHide
        autoHideTimeout={500}
        autoHideDuration={200}
      >
        <Grid className={clsx("pr-4")}>{content}</Grid>
      </Scrollbars>
    </>
  );
};

export default memo(PanelScrollBar);
